<template>
    <div id="main-content" class="schedule-detail">
        <el-col :offset="1" :span="22">
            <PageTitle :title="title" :backLink="backLink"></PageTitle>
            <el-row>
                <el-form :inline="true">
                    <el-form-item :label="$t('common.date')">
                        <el-date-picker
                            v-model="date"
                            type="date"
                            :placeholder="$t('common.pick_a_day')" @change="changeDate">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item v-show="isSave || isSavePickup">
                        <el-button type="primary" @click="save()">{{ $t('common.save') }}</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-tabs v-model="activeName">
              <el-tab-pane :label="$t('common.pickup_route')" name="pickup-route1">
                <SchedulePickupRouteUpdate :dataTemplateSelectedPickup.sync="dataTemplateSelectedPickup" :studentList="pickupStudentListByDate" @updateDataSelect="updateDataSelectPickup" @openStatistic="openStatistic"
                                   :date="dateGenerate || dateString" :masterData="masterData" @onGeneratePickup="onGeneratePickup"
                                   :studentScheduleList="studentScheduleList"></SchedulePickupRouteUpdate>
              </el-tab-pane>
              <el-tab-pane :label="$t('common.drop_route')" name="drop-route">
                  <ScheduleDropRoute :dataTemplateSelected.sync="dataTemplateSelected" :studentList="dropStudentListByDate" @updateDataSelect="updateDataSelect" @openStatistic="openStatistic"
                          :date="dateString" :masterData="masterData"
                          :studentScheduleList="studentScheduleList"></ScheduleDropRoute>
              </el-tab-pane>
              <el-tab-pane :label="$t('common.result')" name="result">
                  <template v-if="activeName === 'result'">
                      <ScheduleResult
                              :pickupStudentList="pickupStudentList"
                              :dropStudentList="dropStudentListByDate"
                              :date="dateString"
                              :masterData="masterData"></ScheduleResult>
                  </template>
              </el-tab-pane>
            </el-tabs>
        </el-col>
        <el-dialog
                :title="$t('common.statistic')"
                :visible.sync="isStatisticOpen"
                width="50%"
                :before-close="closeStatistic">
            <el-row class="statistic-content" :gutter="20">
                <el-col class="statistic-content__col" :span="8" v-for="placeInfo in statistic" :key="placeInfo.id">
                    <h5>{{ placeInfo.name }}</h5>
                    <table>
                        <tr v-for="(classInfo, classId) in sortClass(placeInfo.classList)" :key="classId">
                            <th width="30%">{{ classInfo.name }}</th>
                            <td>{{ classInfo.count }}</td>
                        </tr>
                    </table>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeStatistic">{{ $t('common.cancel') }}</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import ScheduleDropRoute from '@/components/Schedule/ScheduleDropRoute'
  import SchedulePickupRouteUpdate from "../../components/Schedule/SchedulePickupRouteUpdate";
  import ScheduleResult from '@/components/Schedule/ScheduleResult'
  import { ROUTE_PICKUP } from '@/config'
  import { classSort } from '@/utils'

  export default {
    name: 'ListStudent',
    components: {
      PageTitle,
      ScheduleDropRoute,
      ScheduleResult,
      SchedulePickupRouteUpdate
    },
    data: function () {
      return {
        backLink: ``,
        title: 'menu.schedule',
        activeName: 'drop-route',
        date: '',
        dateString: '',
        dropStudentListByDate: [],
        studentScheduleList: [],
        busList: [],
        isStatisticOpen: false,
        statistic: [],
        dataTemplateSelected: null,
        dataTemplateSelectedPickup: null,
        pickupStudentListByDate: [],
        dateGenerate: null,
      }
    },
    created: function () {
      this.date = this.$moment()
      this.changeDate(this.date)
    },
    methods: {
      updateDataSelect(e){
            this.dataTemplateSelected = e
            if(this.dataTemplateSelected.checkLoadTemplate && this.dataTemplateSelected && this.dataTemplateSelected.dataStudent) {
                for (let dat in this.dataTemplateSelected.dataStudent) {
                    if(dat === this.dateString){

                        let listData = [].concat(this.dropStudentList[this.dateString])
                        listData.forEach(item => {
                            if(this.dataTemplateSelected.dataStudent[this.dateString] && this.dataTemplateSelected.dataStudent[this.dateString]['student_'+item.id]){
                                item.bus_id = this.dataTemplateSelected.dataStudent[this.dateString]['student_'+item.id].bus_id
                                item.time = this.dataTemplateSelected.dataStudent[this.dateString]['student_'+item.id].time
                                item.sub_driver_id = this.dataTemplateSelected.dataStudent[this.dateString]['student_'+item.id].sub_driver_id
                            }else{
                                item.bus_id = ''
                                item.sub_driver_id = ''
                            }

                        })
                        this.dropStudentListByDate = [].concat(listData)
                    }
                }
                this.dataTemplateSelected.checkLoadTemplate = false

            }
        },
      updateDataSelectPickup(e){
        this.dataTemplateSelectedPickup = e
        if(this.dataTemplateSelectedPickup.checkLoadTemplate && this.dataTemplateSelectedPickup && this.dataTemplateSelectedPickup.dataStudent) {
          for (let dat in this.dataTemplateSelectedPickup.dataStudent) {
            if(dat === this.dateString){

              let listData = [].concat(this.dropStudentList[this.dateString])
              listData.forEach(item => {
                if(this.dataTemplateSelectedPickup.dataStudent[this.dateString] && this.dataTemplateSelectedPickup.dataStudent[this.dateString]['student_'+item.id]){
                  item.bus_id = this.dataTemplateSelectedPickup.dataStudent[this.dateString]['student_'+item.id].bus_id
                  item.time = this.dataTemplateSelectedPickup.dataStudent[this.dateString]['student_'+item.id].time
                  item.sub_driver_id = this.dataTemplateSelectedPickup.dataStudent[this.dateString]['student_'+item.id].sub_driver_id
                }else{
                  item.bus_id = ''
                  item.sub_driver_id = ''
                }

              })
              this.pickupStudentListByDate = [].concat(listData)
            }
          }
          this.dataTemplateSelectedPickup.checkLoadTemplate = false

        }
      },
      save: function () {
        if(this.activeName === 'pickup-route1'){
          let  dateString = this.$moment(this.date).format('YYYY-MM-DD')
          this.$store.dispatch('schedule/createPickupSchedule', {dataStudentPickup: this.pickupStudentTemplate ? this.pickupStudentTemplate.dataStudent: null , date: dateString })
        }else{
          this.$store.dispatch('schedule/updateScheduleDetail', {dataStudent: this.studentTemplate ? this.studentTemplate.dataStudent : null, dataStudentPickup: this.pickupStudentTemplate ? this.pickupStudentTemplate.dataStudent: null})

        }
      },
      changeDate (date) {
        this.dateString = this.$moment(date).format('YYYY-MM-DD')
        this.dateGenerate = null
        this.retrieveDropStudentList(this.dateString)
        this.retrieveDropRouteTimes(this.dateString)
        this.retrieveStudentScheduleList(this.dateString)
        this.retrievePickupStudentList(this.dateString)
      },
      onGeneratePickup(){
        let date = this.$moment(this.date).format('YYYY-MM-DD')
        this.dateString = this.$moment(this.date).subtract(1 , 'day').format('YYYY-MM-DD')
        this.dateGenerate = this.$moment(this.date).format('YYYY-MM-DD')
        this.retrievePickupStudentListGenerate(this.dateString , date)
        this.$store.commit('schedule/updateSavePickup', {status:  true})
      },
      retrieveDropStudentList(date) {
        this.$store.dispatch('schedule/retrieveDropStudentList', {
          date,
          successCallback: () => {
              let listData = [].concat(this.dropStudentList[date])
              if(this.studentTemplate && this.studentTemplate.dataStudent && this.studentTemplate.dataStudent[date]) {
                  listData.forEach(item => {
                      if(this.studentTemplate.dataStudent[date]['student_'+item.id]){
                          item.bus_id = this.studentTemplate.dataStudent[date]['student_'+item.id].bus_id
                          item.time = this.studentTemplate.dataStudent[date]['student_'+item.id].time
                          item.sub_driver_id = this.studentTemplate.dataStudent[date]['student_'+item.id].sub_driver_id
                      }else{
                          item.bus_id = ''
                          item.time = ''
                          item.sub_driver_id = ''
                      }

                  })

                  this.dropStudentListByDate = [].concat(listData)
                  this.$store.commit('schedule/updateSave', {status:  true})
              }else{
                  this.dropStudentListByDate = [].concat(listData)
                  this.$store.commit('schedule/updateSave', {status:  false})
              }

          }
        })
      },
      retrievePickupStudentList(date) {
        this.$store.dispatch('schedule/retrievePickupStudentListUpdate', {
          date,
          successCallback: () => {
            let listData = [].concat(this.pickupStudentListUpdate[date])
            if(this.pickupStudentTemplate && this.pickupStudentTemplate.dataStudent && this.pickupStudentTemplate.dataStudent[date]) {
              listData.forEach(item => {
                if(this.pickupStudentTemplate.dataStudent[date]['student_'+item.id]){
                  item.bus_id = this.pickupStudentTemplate.dataStudent[date]['student_'+item.id].bus_id
                  item.time = this.pickupStudentTemplate.dataStudent[date]['student_'+item.id].time
                  item.sub_driver_id = this.pickupStudentTemplate.dataStudent[date]['student_'+item.id].sub_driver_id
                }else{
                  item.bus_id = ''
                  item.time = ''
                  item.sub_driver_id = ''
                }

              })

              this.pickupStudentListByDate = [].concat(listData)
              this.$store.commit('schedule/updateSavePickup', {status:  true})
            }else{
              this.pickupStudentListByDate = [].concat(listData)
              this.$store.commit('schedule/updateSavePickup', {status:  false})
            }

          }
        })
      },
      retrievePickupStudentListGenerate(date, dateGenerate) {
        this.$store.dispatch('schedule/retrievePickupStudentListUpdate', {
          date,
          dateGenerate,
          successCallback: () => {
            let listData = [].concat(this.pickupStudentListUpdate[dateGenerate])
            if(this.pickupStudentTemplate && this.pickupStudentTemplate.dataStudent && this.pickupStudentTemplate.dataStudent[dateGenerate]) {
              listData.forEach(item => {
                if(this.pickupStudentTemplate.dataStudent[dateGenerate]['student_'+item.id]){
                  item.bus_id = this.pickupStudentTemplate.dataStudent[dateGenerate]['student_'+item.id].bus_id
                  item.time = this.pickupStudentTemplate.dataStudent[dateGenerate]['student_'+item.id].time
                  item.sub_driver_id = this.pickupStudentTemplate.dataStudent[dateGenerate]['student_'+item.id].sub_driver_id
                }else{
                  item.bus_id = ''
                  item.time = ''
                  item.sub_driver_id = ''
                }

              })

              this.pickupStudentListByDate = [].concat(listData)
            }else{
              this.pickupStudentListByDate = [].concat(listData)
            }

          }
        })
      },
      retrieveDropRouteTimes(date) {
        this.$store.dispatch('schedule/retrieveDropRouteTimes', {
          date
        })
      },

      retrieveStudentScheduleList (date) {
        this.$store.dispatch('schedule/retrieveStudentScheduleList', {
          date,
          successCallback: (response) => {
            this.studentScheduleList = [].concat(response.data.data.student_schedule_list)
          }
        })
      },
      closeStatistic: function () {
        this.isStatisticOpen = false
      },
      openStatistic (payload) {
        let studentList = payload.studentList
        let routeType = payload.routeType
        let cancelStudentList = []
        let routeField = routeType === ROUTE_PICKUP ? 'pickup' : 'drop'
        let statistic = {}

        this.studentScheduleList.forEach((item) => {
          if (!item[routeField]) {
            cancelStudentList.push(item.id)
          }
        })
        if(routeType === ROUTE_PICKUP){
          studentList.forEach((item) => {
            if (cancelStudentList.indexOf(item.id) === -1 && item.place && item.class_entity) {
              if (typeof statistic[item.place.id] === 'undefined') {
                statistic[item.place.id] = {
                  id: item.place.id,
                  name: item.place.name,
                  classList: {}
                }
              }

              if (typeof statistic[item.place.id].classList[item.class_entity.id] === 'undefined') {
                statistic[item.place.id].classList[item.class_entity.id] = {
                  id: item.class_entity.id,
                  name: item.class_entity.name,
                  count: 0
                }
              }

              statistic[item.place.id].classList[item.class_entity.id].count++
            }
          })
        }else{
          studentList.forEach((item) => {
            if (cancelStudentList.indexOf(item.id) === -1 && item.place_info && item.class_info) {
              if (typeof statistic[item.place_info.id] === 'undefined') {
                statistic[item.place_info.id] = {
                  id: item.place_info.id,
                  name: item.place_info.name,
                  classList: {}
                }
              }

              if (typeof statistic[item.place_info.id].classList[item.class_info.id] === 'undefined') {
                statistic[item.place_info.id].classList[item.class_info.id] = {
                  id: item.class_info.id,
                  name: item.class_info.name,
                  count: 0
                }
              }

              statistic[item.place_info.id].classList[item.class_info.id].count++
            }
          })
        }


        this.statistic = Object.values(statistic).sort((before, after) => {
          let beforeName = before.name.toLowerCase()
          let afterName = after.name.toLowerCase()

          return beforeName < afterName ? -1 : beforeName > afterName ? 1 : 0
        })

        this.isStatisticOpen = true
      },
      sortClass (classList) {
        let sortedClassList = Object.values(classList)
        sortedClassList.sort((before, after) => classSort(before, after))
        return sortedClassList
      }
    },
    mounted: function () {
      // this.$store.dispatch('schedule/retrievePickupStudentList', {})
      this.$store.dispatch('schedule/retrieveMasterData', {})
    },
    computed: {
      ...mapState('schedule', ['pickupStudentList','pickupStudentListUpdate', 'dropStudentList', 'masterData', 'isSave', 'isSavePickup', 'studentTemplate', 'pickupStudentTemplate'])
    },
      watch:{
          studentTemplate:{
              deep: true,
              handler: function () {
                  if(this.studentTemplate.checkLoadTemplate){
                      for (let dat in this.studentTemplate.dataStudent) {
                          if(dat === this.dateString){
                              let listData = [].concat(this.dropStudentList[this.dateString])
                              listData.forEach(item => {
                                  if(this.studentTemplate.dataStudent[this.dateString] && this.studentTemplate.dataStudent[this.dateString]['student_'+item.id]){
                                      item.bus_id = this.studentTemplate.dataStudent[this.dateString]['student_'+item.id].bus_id
                                      item.time = this.studentTemplate.dataStudent[this.dateString]['student_'+item.id].time
                                      item.sub_driver_id = this.studentTemplate.dataStudent[this.dateString]['student_'+item.id].sub_driver_id
                                  }else{
                                      item.bus_id = ''
                                      item.time = ''
                                      item.sub_driver_id = ''
                                  }

                              })
                              this.dropStudentListByDate = [].concat(listData)
                              this.$store.commit('schedule/updateSave', {status:  true})
                          }
                      }
                      this.studentTemplate.checkLoadTemplate = false
                      this.$store.commit('schedule/updateStudentTemplate', {
                          data: this.studentTemplate
                      })
                  }

              }
          },
          pickupStudentTemplate:{
            deep: true,
            handler: function () {
              if(this.pickupStudentTemplate.checkLoadTemplate){
                for (let dat in this.pickupStudentTemplate.dataStudent) {
                  if(dat === this.dateString){
                    let listData = [].concat(this.pickupStudentListUpdate[this.dateString])
                    listData.forEach(item => {
                      if(this.pickupStudentTemplate.dataStudent[this.dateString] && this.pickupStudentTemplate.dataStudent[this.dateString]['student_'+item.id]){
                        item.bus_id = this.pickupStudentTemplate.dataStudent[this.dateString]['student_'+item.id].bus_id
                        item.time = this.pickupStudentTemplate.dataStudent[this.dateString]['student_'+item.id].time
                        item.sub_driver_id = this.pickupStudentTemplate.dataStudent[this.dateString]['student_'+item.id].sub_driver_id
                      }else{
                        item.bus_id = ''
                        item.time = ''
                        item.sub_driver_id = ''
                      }

                    })
                    this.pickupStudentListByDate = [].concat(listData)
                    this.$store.commit('schedule/updateSavePickup', {status:  true})
                  }
                }
                this.pickupStudentTemplate.checkLoadTemplate = false
                this.$store.commit('schedule/updateStudentTemplatePickup', {
                  data: this.pickupStudentTemplate
                })
              }

            }
          },
          dropStudentList:{
              deep: true,
              handler: function () {
                  if(this.studentTemplate && this.studentTemplate.dataStudent && this.studentTemplate.dataStudent[this.dateString]){
                      this.dropStudentList[this.dateString].forEach(item=>{
                          if(item.bus_id){
                              for(let date in this.studentTemplate.dataStudent){
                                  if(date === this.dateString){
                                      if(this.studentTemplate.dataStudent[this.dateString]){
                                          let data = {
                                              id: item.id,
                                              bus_id: item ? item.bus_id : "",
                                              sub_driver_id: item.sub_driver_id || "",
                                              time: item.time ? item.time.substring(0,5) : ""
                                          }
                                          this.studentTemplate.dataStudent[this.dateString]['student_'+item.id] = data
                                      }
                                  }else{
                                      this.studentTemplate.dataStudent[date] =  Object.assign({},this.studentTemplate.dataStudent[date])
                                  }
                              }

                          }
                      })
                      this.$store.commit('schedule/updateStudentTemplate', {
                          data: this.studentTemplate
                      })

                  }
              }
          },
          pickupStudentListUpdate:{
            deep: true,
            handler: function () {
              if(this.pickupStudentTemplate && this.pickupStudentTemplate.dataStudent && this.pickupStudentTemplate.dataStudent[this.dateString]){
                this.pickupStudentListUpdate[this.dateString].forEach(item=>{
                  if(item.bus_id){
                    for(let date in this.pickupStudentTemplate.dataStudent){
                      if(date === this.dateString){
                        if(this.pickupStudentTemplate.dataStudent[this.dateString]){
                          let data = {
                            id: item.id,
                            time: item.time ? item.time.substring(0,5) : "",
                            bus_id: item ? item.bus_id : "",
                            sub_driver_id: item.sub_driver_id || ""
                          }
                          this.pickupStudentTemplate.dataStudent[this.dateString]['student_'+item.id] = data
                        }
                      }else{
                        this.pickupStudentTemplate.dataStudent[date] =  Object.assign({},this.pickupStudentTemplate.dataStudent[date])
                      }
                    }

                  }
                })
                this.dateGenerate = null
                this.$store.commit('schedule/updateStudentTemplatePickup', {
                  data: this.pickupStudentTemplate
                })

              }

            }
          }
      }
  }
</script>
<style lang="scss">
    .schedule-detail {
        .input {
            float: none!important;
            outline: none;
            background: #fff;
            width: 100%;
        }

        .input[type="text"], select {
            color: #2c3e50;
            font-weight: normal;
        }

        select {
            cursor: pointer;
        }

        .hidden {
            display: none;
        }

        table {
            th, td {
                padding: 10px;
            }

            tr {
                &.cant-pick {
                    td {
                        position: relative;

                        &::before {
                            display: block;
                            width: 100%;
                            height: 100%;
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            background: rgba(255, 255, 255, 0.7);
                        }
                    }
                }

                &.pickup-canceled, &.drop-canceled {
                    background: rgba(202, 0, 0, 0.5);
                }
            }
        }

        &__count {
            margin: 20px 0;
        }
    }

    .statistic-content {
        table {
            width: 100%;
        }

        &__col {
            margin-bottom: 20px;
        }
    }
</style>
